"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("react");
const react_hooks_1 = require("@apollo/react-hooks");
const apollo_utilities_1 = require("apollo-utilities");
const context_1 = require("./context");
exports.OsmosysCanvasPageQueryLoader = react_1.memo((_a) => {
    var { name, query } = _a, options = tslib_1.__rest(_a, ["name", "query"]);
    if (!name) {
        throw new Error('No name provided');
    }
    const { dispatchCanvasAction } = context_1.useOsmosysCanvasPageUpdateContext();
    const result = react_hooks_1.useQuery(query, options);
    react_1.useEffect(() => {
        dispatchCanvasAction({
            data: {
                [name]: {
                    options,
                    result: {
                        data: result.data,
                        error: result.error,
                        loading: result.loading,
                        refetch: result.refetch,
                    },
                },
            },
            type: 'canvasQueries',
        });
    }, [result.data, result.loading, result.error]);
    return null;
}, (prevProps, nextProps) => {
    if (prevProps.name !== nextProps.name) {
        return true;
    }
    if (!apollo_utilities_1.isEqual(prevProps.variables, nextProps.variables)) {
        return true;
    }
    return false;
});
exports.OsmosysCanvasPageQueryLoader.displayName = 'OsmosysCanvasPageQueryLoader';
//# sourceMappingURL=QueryLoader.js.map